import { AbsenceInboxCard } from "@/components/cards/absence-inbox-card";
import { useUserAbsences } from "@/hooks/use-user-absences";
import { Button, ButtonGroup } from "@msuite/ui/button";
import { useTranslation } from "@msuite/ui/localization";
import { Modal, type ModalProps } from "@msuite/ui/modal";
import { guardArray } from "@msuite/utils/array";
import { useMemo } from "react";

/** Props Interface */
interface AbsencesOverviewModalProps extends ModalProps {
	userId: string;
	targetDate?: string;
}

export function AbsencesOverviewModal({
	userId,
	targetDate,
	isOpen,
	onClose,
}: AbsencesOverviewModalProps) {
	/** Hooks */
	const { t } = useTranslation();

	const { data, isLoading } = useUserAbsences(userId, { date: targetDate });

	const absences = useMemo(() => {
		return [
			{ title: t("absences.current"), items: guardArray(data?.current) },
			{ title: t("absences.upcoming"), items: guardArray(data?.upcoming) },
		].filter((item) => !!item.items.length);
	}, [data]);

	/** Render */
	return (
		<Modal
			title={t("absences.absences")}
			isOpen={isOpen}
			onClose={onClose}
			isLoading={isLoading}
			width="50rem"
		>
			<Modal.Body>
				{absences.map((absenceSection) => (
					<div
						className="v-stack"
						key={absenceSection.title}
					>
						<p className="label">{absenceSection.title}</p>
						{absenceSection.items.map((absenceItem) => (
							<AbsenceInboxCard
								absence={absenceItem}
								key={absenceItem.id}
								withControls={false}
							/>
						))}
					</div>
				))}
			</Modal.Body>
			<Modal.Footer>
				<ButtonGroup>
					<Button
						onClick={onClose}
						variant="primary"
					>
						{" "}
						{t("general.done")}
					</Button>
				</ButtonGroup>
			</Modal.Footer>
		</Modal>
	);
}
